module.exports = __webpack_public_path__ + "img/state5.a9db6204.png";